// const baseUrl = "https://ivoapi.vinnisoft.com/";
const baseUrl = "https://ivodev.vinnisoft.org/";
// const baseUrl = "http://192.168.1.28:8000/";;
const endPointUrl = baseUrl + "api";

const constants = { baseUrl, endPointUrl };

export default constants;
